import { selectFieldClass } from './fieldClasses';

export type WalletOption = { id: number; name: string };

type Props = {
  id: string;
  wallets: WalletOption[];
  value: number;
  onChange: (walletId: number) => void;
  placeholder: string;
  className?: string;
};

export function WalletSelect({ id, wallets, value, onChange, placeholder, className }: Props) {
  return (
    <select
      id={id}
      className={className ?? selectFieldClass}
      value={value || ''}
      onChange={(e) => onChange(Number(e.target.value))}
    >
      <option value="">{placeholder}</option>
      {wallets.map((w) => (
        <option key={w.id} value={w.id}>
          {w.name}
        </option>
      ))}
    </select>
  );
}
